import { useQueryParam } from "@/hooks/useQueryParam";

export const useSimIdFromQueryParam = () => useQueryParam("simId");
